var app = {
	header: {
		build: "Сборка",
		closeButton: "Закрыть",
		copyrightLabel: "Авторское право",
		helpLabel: "Помощь",
		legalNoticeLabel: "Юридическое уведомление",
		logoutButton: "Выйти",
		menuLabel: "Меню",
		module: "Модуль",
		myData: "Мои данные",
		noUserDataLabel: "Данные пользователя отсутствуют",
		notificationsLabel: "Уведомления",
		privacyPolicyLabel: "Политика конфиденциальности",
		search: "Поиск",
		searchPlaceholder: "Поисковый запрос или вопрос",
		serviceAppLabel: "Сервисное приложение",
		settingsLabel: "Настройки",
		shopLabel: "Магазин",
		smartFactorySuiteLabel: "Пакет Smart-Factory",
		softwareInformation: "Информация о программном обеспечении",
		toMytrumpf: "К MyTRUMPF",
		toTrumpfCom: "К trumpf.com",
		userLabel: "Профиль",
		userProfileLinkText: "Профиль пользователя",
		version: "Версия"
	}
};
var contentLoadingError = "Содержимое не может быть загружено";
var dashboard = {
	cancel: {
		button: "Отмена"
	},
	edit: {
		button: "Редактировать"
	},
	reset: {
		button: "Сброс"
	},
	save: {
		button: "Сохранить"
	},
	share: {
		button: "Поделиться"
	}
};
var fileUpload = {
	invalidFileType: "Файл имеет неправильный тип",
	maxFileSize: "Файл больше допустимого размера (макс. {{maxSizeInMb}} МБ)",
	maxFilesReached: "Достигнуто максимальное количество файлов"
};
var filter = {
	clear: "Сбросить фильтры",
	clearAll: "Сбросить все фильтры"
};
var general = {
	nextButton: "Далее",
	prevButton: "Назад",
	resetButton: "Сброс"
};
var locationMap = {
	locationLink: {
		label: "Перейти к местоположению"
	}
};
var machineDiscontinuation = {
	linkText: "Узнать больше"
};
var notifications = {
	button: {
		loadMore: "Загрузить еще"
	},
	date: {
		lastMonth: "Последний месяц",
		lastWeek: "Последняя неделя",
		older: "Старше",
		thisMonth: "Этот месяц",
		thisWeek: "Эта неделя",
		today: "Сегодня",
		yesterday: "Вчера"
	},
	error: {
		general: "В настоящее время уведомления не могут быть отображены. Пожалуйста, попробуйте позже.",
		unauthorized: "Пожалуйста, войдите, чтобы видеть уведомления"
	},
	info: {
		activateSettings: "Чтобы получать уведомления, пожалуйста, включите их в настройках",
		noNotification: "В настоящее время для вас нет сообщений."
	},
	title: "Уведомления"
};
var results = {
	counter: {
		label: "результатов"
	}
};
var scrollToTop = {
	label: "Прокрутить вверх"
};
var slider = {
	nextButton: {
		label: "Следующий слайд"
	},
	paginationBullet: {
		label: "Слайд"
	},
	prevButton: {
		label: "Предыдущий слайд"
	}
};
var sorting = {
	ascending: "По возрастанию",
	descending: "По убыванию"
};
var userAccount = {
	address: {
		label: "Почтовый адрес"
	},
	email: {
		label: "Электронная почта"
	},
	language: {
		label: "Язык",
		locale: "Локаль",
		select: "Выбрать язык",
		settings: "Настройки языка"
	},
	loggedOut: {
		message: "Вы не вошли в систему"
	},
	login: {
		button: "Войти"
	},
	name: {
		label: "Имя"
	},
	phone: {
		label: "Телефон"
	}
};
var widget = {
	filter: {
		machine: {
			filter: "Фильтровать машины",
			label: "Машины",
			option: {
				all: "Все машины"
			},
			select: "Выбрать машину"
		},
		period: {
			label: "Период",
			option: {
				currentMonth: "Этот месяц",
				currentWeek: "Эта неделя",
				lastMonth: "Прошлый месяц",
				lastWeek: "Прошлая неделя",
				today: "Сегодня",
				yesterday: "Вчера"
			}
		}
	}
};
var widgetRegistry = {
	allWidgets: {
		label: "Мои виджеты"
	},
	noDescriptionAvailable: "Описание отсутствует.",
	widget: {
		SampleMyMachines: {
			title: "Мои машины"
		},
		SampleMyServiceCalls: {
			title: "Запросы на обслуживание"
		},
		SampleMyTrackingList: {
			title: "Список отслеживания"
		},
		SampleMyUserAccount: {
			title: "Мой профиль"
		},
		SampleOperationalStatesChart: {
			title: "Рабочие состояния"
		},
		SampleWidgetFilter: {
			title: "Настройки фильтра"
		},
		SampleWorkloadBalanceChart: {
			title: "Баланс рабочей нагрузки"
		}
	}
};
var translation = {
	app: app,
	contentLoadingError: contentLoadingError,
	dashboard: dashboard,
	fileUpload: fileUpload,
	filter: filter,
	general: general,
	locationMap: locationMap,
	machineDiscontinuation: machineDiscontinuation,
	notifications: notifications,
	results: results,
	scrollToTop: scrollToTop,
	slider: slider,
	sorting: sorting,
	userAccount: userAccount,
	widget: widget,
	widgetRegistry: widgetRegistry
};

export { app, contentLoadingError, dashboard, translation as default, fileUpload, filter, general, locationMap, machineDiscontinuation, notifications, results, scrollToTop, slider, sorting, userAccount, widget, widgetRegistry };
